import React, { useState } from 'react';
import '../styles.scoped.scss';
import { FaExpand } from 'react-icons/fa';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';

const Tabs = ({ tabs, tabPanels, showExpand = false, handleExpand }) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className='wf-tabs'>
      <div className={`d-flex ${showExpand ? 'justify-content-between' : ''}`}>
        {tabs.map((tab) => {
          return (
            <div key={tab.id}>
              <button
                className={`wf-tab-item ${
                  activeTab === tab.id ? 'wf-tab-active' : ''
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.icon} <span>{tab.title}</span>
              </button>
            </div>
          );
        })}
        {showExpand && (
          <div className='d-flex align-items-center mr-4' onClick={handleExpand}>
            <OverlayTrigger
              placement='left'
              overlay={<Tooltip id='button-tooltip'>Expand Response</Tooltip>}
            >
              <Button>
                <FaExpand />
              </Button>
            </OverlayTrigger>
          </div>
        )}
      </div>
      <div className='w-100'>
        {tabPanels.length > 0 &&
          tabPanels.map((panel) => {
            return (
              <div key={panel.id} className='wf-tab-panel'>
                {activeTab === panel.id && (
                  <div className='mt-2'>{panel.content}</div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Tabs;
